import React from "react";
import LeadsModular from "./leads/index.js";

const Leads = () => {
  console.log("Rendering Leads component");
  return <LeadsModular />;
};

export default Leads; 